import React, { Component } from "react";
import {Button,Box,Menu,MenuButton,MenuList,MenuItem} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faBookmark, faTrashRestore } from "@fortawesome/free-solid-svg-icons";






export default class HistoryGridLayoutButtonStrip extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.onBtnSaveLayout = this.onBtnSaveLayout.bind(this);
    this.onBtnResetLayout = this.onBtnResetLayout.bind(this);
    this.onBtnRestoreLayout = this.onBtnRestoreLayout.bind(this);

  }

  onBtnSaveLayout() {
    /*
    var newGridColState = this.gridColumnApi.getColumnState();
    this.auth.setUserProp(
      this.state.schemaId + "::" + GRIDCOLSTATE,
      JSON.stringify(newGridColState)
    );
    */
  }

  onBtnResetLayout() {
    /*
    this.gridColumnApi.resetColumnState();
    this.gridColumnApi.resetColumnGroupState();
    this.gridApi.setSortModel(null);
    this.gridApi.setFilterModel(null);
    */
  }

  onBtnRestoreLayout() {
    /*
    var savedColState = JSON.parse(
      this.auth.getUserProp(this.state.schemaId + "::" + GRIDCOLSTATE)
    );
    if (savedColState) {
      this.gridColumnApi.setColumnState(savedColState);
    }
    */
  }




  async componentDidUpdate(prevProps, prevState) {
    if (this.props.searchParamsKey !== prevProps.searchParamsKey) {

    }
  }


  render() {

    return (

      <Box marginLeft='10px'>
        <Menu >
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            bg='#0095c8'
            color='white'
            fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Layout
          </MenuButton>
          <MenuList>
            <MenuItem id="saveLayout" icon={<FontAwesomeIcon icon={faSave} />} onClick={this.props.onSaveLayoutRequest}>Save Layout</MenuItem>
            <MenuItem id="restoreLayout" icon={<FontAwesomeIcon icon={faTrashRestore} />} onClick={this.props.onRestoreLayoutRequest}>Restore Layout</MenuItem>
            <MenuItem id="resetLayout" icon={<FontAwesomeIcon icon={faBookmark} />} onClick={this.props.onResetLayoutRequest}>Default Layout</MenuItem>
          </MenuList>
        </Menu>
      </Box>

    );
  }
}
